import { Button, Form, Tooltip } from "antd";
import React, { useState } from "react";
import { ExportOutlined } from "@ant-design/icons";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";
import { saveCopyOnAtts } from "./saveCopyOnAtts";
import { edAttrField } from "../../EdAttribute";
import { ZPermissions } from "../roleTypes";

interface PropsCopyOnAttsButton {
  stateName: string;
  stateId: ZUid;
  objectName: string;
  attributeIds: ZUid[];
}

export const CopyOnAttsButton: React.FC<PropsCopyOnAttsButton> = ({
  stateName,
  stateId,
  objectName,
  attributeIds,
}) => {
  const curPermissonsItem: ZPermissions | undefined = Form.useWatch([
    edAttrField.rolesMap,
    String(stateId),
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  if (!attributeIds.length || !curPermissonsItem) return null;

  const copyOnAttributes = async () => {
    setLoading(true);
    return saveCopyOnAtts(stateId, attributeIds, curPermissonsItem)
      .catch(onError)
      .finally(() => setLoading(false));
  };

  return (
    <Tooltip
      title={`Перенести на состояние ${stateName} для всех атрибутов объекта ${objectName}`}
    >
      <Button
        size="small"
        type="text"
        icon={<ExportOutlined />}
        loading={loading}
        onClick={(event) => {
          event.stopPropagation();
          copyOnAttributes();
        }}
      />
    </Tooltip>
  );
};
